import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { history } from "../../../../store/configure/configureStore";
import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import queryString from "query-string";
import {
  MOBILE_USER_ACTIVITY_LOG,
  MOBILE_APP_USER_MANAGEMENT,
} from "../../../../navigation/routes";
//
import {
  getMobileAppUserActivityLogsById,
  //
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
} from "../../../../store/mobileAppUserManagement/mobileAppUserManagementActions";
//
import MobileUserDetailsView from "./MobileUserActivityDetailsView";

class MobileUserActivityDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate() {}

  componentDidMount() {
    // Accessing the URL params
    const activityLogId = this.props.match.params.id;
    this.props.getMobileAppUserActivityLogsById(activityLogId);
  }

  componentWillUnmount() {
    const location = window?.location?.pathname;
    if (
      !location?.includes(MOBILE_APP_USER_MANAGEMENT) &&
      !location?.includes(MOBILE_USER_ACTIVITY_LOG)
    ) {
      //--------------------------reset redux rowsPerPage state when unmounting
      const resetRowsPerPageData = { label: "10", value: 10 };
      this.props?.updateRowsPerPage(resetRowsPerPageData);
      this.props?.updateCurrentPage(1);
      //--------------------------reset redux fields state when unmounting
      const resetFields = { searchString: "" };
      this.props.updateSearchFilters(resetFields);
    }
  }

  onClickCancel = () => {
    history?.goBack();
  };

  render() {
    const { mobileUserActivityLogById } = this.props;
    return (
      <MobileUserDetailsView
        mobileUserActivityLogById={mobileUserActivityLogById}
        //handler functions
        onClickCancel={this.onClickCancel}
      />
    );
  }
}

MobileUserActivityDetailsContainer.propTypes = {};

const mapStateToProps = (state) => ({
  mobileUserActivityLogById:
    state.mobileUserManagement.mobileUserActivityLogById,
});

export default connect(mapStateToProps, {
  getMobileAppUserActivityLogsById,
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
})(MobileUserActivityDetailsContainer);
